<script setup>
import { ref, watch, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'
import { usePortalStore } from '@/store/portal'
const portal = usePortalStore()
import AppIcon from './AppIcon.vue'
const route = useRoute(), open = ref(false), nav = ref(null), toggle = ref(null)
const active = menu => route.path === menu.to || route.path.startsWith(`${menu.to}/`)
function close(restore = false) { open.value = false; if (restore) toggle.value?.focus() }
function pointer(event) { if (!nav.value?.contains(event.target)) close() }
function focusout(event) { if (!nav.value?.contains(event.relatedTarget)) close() }
function keydown(event) { if (event.key === 'Escape') { event.preventDefault(); close(nav.value?.contains(document.activeElement)) } }
// disclosure는 문서를 가리지 않는다. Escape는 토글로 복귀하고 경로 이동/외부 클릭은 닫기만 한다.
watch(open, value => {
  document[value ? 'addEventListener' : 'removeEventListener']('pointerdown', pointer)
  document[value ? 'addEventListener' : 'removeEventListener']('keydown', keydown)
})
watch(() => route.fullPath, () => close())
onBeforeUnmount(() => { document.removeEventListener('pointerdown', pointer); document.removeEventListener('keydown', keydown) })
</script>
<template>
  <nav ref="nav" class="portal-nav" :class="{ open }" aria-label="주요 메뉴" @focusout="focusout">
    <div class="portal-container nav-row">
      <button ref="toggle" class="portal-nav-all" type="button" :aria-expanded="open" aria-controls="portal-all-menu" :aria-label="open ? '전체 메뉴 닫기' : '전체 메뉴 열기'" @click="open = !open"><AppIcon :name="open ? 'close' : 'menu'" :size="26" :stroke-width="1.6" /><span class="portal-nav-all-text">전체메뉴</span></button>
      <!-- 레거시 GNB: 138px 칸 8개(첫 칸 x=450 @1920). 마우스를 올리면 같은 폭의 하위 메뉴가 내려온다(키보드는 전체메뉴로 이동). -->
      <ul class="portal-nav-list">
        <li v-for="menu in portal.menus" :key="menu.to" class="portal-nav-item" :class="{ classroom: menu.requiresAuth }">
          <NuxtLink :to="menu.href" class="portal-nav-link" :class="{ active: active(menu) }" :aria-current="route.path === menu.href ? 'page' : active(menu) ? 'location' : undefined">{{ menu.title }}</NuxtLink>
          <ul v-if="menu.children.length" class="portal-nav-drop"><li v-for="child in menu.children" :key="child.to"><NuxtLink :to="child.to" tabindex="-1">{{ child.title }}</NuxtLink></li></ul>
        </li>
      </ul>
    </div>
    <div v-if="open" id="portal-all-menu" class="portal-mega" role="region" aria-label="전체 메뉴">
      <div class="portal-mega-grid">
        <section v-for="(menu, index) in portal.menus" :key="menu.to" class="portal-mega-column" :aria-labelledby="`menu-heading-${index}`">
          <h2 :id="`menu-heading-${index}`">{{ menu.title }}</h2>
          <ul><li v-for="child in menu.children" :key="child.to"><NuxtLink :to="child.to" :aria-current="route.path === child.to ? 'page' : undefined" @click="close()">{{ child.title }}</NuxtLink></li></ul>
        </section>
      </div>
    </div>
  </nav>
</template>
